import get from 'lodash/get';
import { func, oneOfType, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { errorShape } from '../../prop-types';

function SuccessComponent({ success, component: Component, ...rest }) {
  const detail = get(success, ['data', 'detail']);
  return (
    <Component color="success" {...rest}>
      {success.message}
      {detail && <div>{detail}</div>}
    </Component>
  );
}

SuccessComponent.propTypes = {
  success: errorShape.isRequired,
  component: oneOfType([func, string]),
  className: string,
};

SuccessComponent.defaultProps = {
  component: Alert,
  className: 'white-space-pre-wrap',
};

export default SuccessComponent;
